import { Modal } from "@msys/ui";
import React from "react";
import { useTranslate } from "@tolgee/react";
import { CrmCompanyEditForm } from "./CrmCompanyEditForm.js";
import { Link } from "react-router-dom";

interface Props {
  crmCompanyId: string;
  handleClose: () => void;
}

export const CrmCompanyEditModal = ({ crmCompanyId, handleClose }: Props) => {
  const { t } = useTranslate(["CrmOrganisations", "Global"]);
  return (
    <Modal
      handleClose={handleClose}
      title={t("Edit CRM record", { ns: "CrmOrganisations" })}
      actionButtons={[
        {
          label: t("Go to CRM page", { ns: "CrmOrganisations" }),
          buttonProps: {
            variant: "text",
            component: Link,
            // @ts-ignore
            to: `/crm/organisations/${crmCompanyId}`,
          },
        },
      ]}
    >
      <CrmCompanyEditForm crmCompanyId={crmCompanyId} />
    </Modal>
  );
};
